import { render, staticRenderFns } from "./ListingFrozenBanner.vue?vue&type=template&id=63e83e5a"
import script from "./ListingFrozenBanner.vue?vue&type=script&lang=js"
export * from "./ListingFrozenBanner.vue?vue&type=script&lang=js"
import style0 from "./ListingFrozenBanner.vue?vue&type=style&index=0&id=63e83e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports